export const Production =
  process.env.REACT_APP_HONEYBADGER_ENV === 'production';

export const ApiHost = process.env.REACT_APP_API_HOST;
export const AppHost = process.env.REACT_APP_APP_HOST;
export const DeeplinkHost = process.env.REACT_DEEPLINK_HOST
  ? process.env.REACT_DEEPLINK_HOST
  : AppHost;

export const IntercomAppId = 't7hu5fca';
export const GoogleAnalyticsId = Production ? 'G-VMPKPB7NR7' : 'G-GCNKH6KEHV';

export const MaydayChromeExtensionId =
  process.env.REACT_APP_CHROME_EXTENSION_ID;
export const MaydayEdgeExtensionId = process.env.REACT_APP_EDGE_EXTENSION_ID;

export const MonthFormatString = 'MMMM yyyy';
export const DateFormatString = 'dd LLL yyyy';
export const DateTimeFormatString = `${DateFormatString} HH:mm`;

export const PaddleJsUrlClassic = 'https://cdn.paddle.com/paddle/paddle.js'; // Paddle Classic is the old version
export const PaddleJsUrlBilling = 'https://cdn.paddle.com/paddle/v2/paddle.js'; // Paddle Billing is the new V2 that we use following pricing restructure 2024_06
export const PaddleClientTokenTest = 'test_36d46457bb7b6e333a36ad42643';
export const PaddleClientTokenProduction = 'live_ffda165e95523332dd40262cd84';

export const ErrorBorder = 'border-2 border-red';

export const PaddleConfig = {
  VendorId: parseInt(process.env.REACT_APP_PADDLE_VENDOR_ID),
};

export const HoneybadgerApiKey = process.env.REACT_APP_HONEYBADGER_APIKEY;
export const HoneybadgerEnv = process.env.REACT_APP_HONEYBADGER_ENV;
